import { PipeTransform, Pipe } from '@angular/core';
import { formatDate } from '@angular/common';
import { DPO_CONSTANT } from './../utils/constant';

// Define a pipe for date format
@Pipe({ name: 'date' })
export class DatePipe implements PipeTransform {

    // Transform method to handle the pipe execution.
    transform(date: string | Date): string {
        let formattedDate: string = '';
        /* Cap-20753 : Start: Added if condition for date as NA */
        
            /* Cap-20753: End */
        let dateObj = new Date(date);
        if (date && dateObj) {
            formattedDate = formatDate(dateObj, DPO_CONSTANT.DATE_FROMAT, 'EN-EN');
        }
        return formattedDate;
        
    }
}
